"use client";

import { TariffVersionForm } from "./TariffVersionForm";
import { useEnumOptions } from "@/hooks/settings/useEffectiveEnums";
import type { TariffVersion } from "@/types/billing";
import type {
  TariffVersionFormData,
  TariffVersionFormInput,
} from "@/schemas/tariffValidationSchemas";

interface TariffVersionFormWithEnumsProps {
  initialData?: TariffVersion;
  onSubmit: (data: TariffVersionFormData) => Promise<void>;
  onCancel: () => void;
  isLoading?: boolean;
  isCopy?: boolean;
  isEdit?: boolean;
  onActivate?: (formData: TariffVersionFormInput) => Promise<void>;
  isActivating?: boolean;
  canActivate?: boolean;
  onCopy?: () => void;
  canCopy?: boolean;
  onArchive?: () => Promise<unknown> | void;
  isArchiving?: boolean;
  canArchive?: boolean;
  onEditRates?: () => void;
  canEditRates?: boolean;
  versions?: TariffVersion[];
}

// Wrapper component that adds custom enum support for group types
export function TariffVersionFormWithEnums(props: TariffVersionFormWithEnumsProps) {
  // Fetch custom enum options for group types
  const { options: groupTypeOptions, isLoading: isLoadingGroupTypes } = useEnumOptions('groups', 'type');

  // Pass the custom enum options to the form
  return (
    <TariffVersionForm 
      {...props} 
      groupTypeOptions={groupTypeOptions.length > 0 ? groupTypeOptions : undefined}
      isLoadingEnums={isLoadingGroupTypes}
    />
  );
}